import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Iconbutton element, used for clickable icons with specific action
 *
 * @prop {String} icon - used to define a Fontawesome icon
 * @prop {String} link - used to define a url that is triggered after the click action
 * @prop {String} target - used to define the url target
 * @prop {Number} size - used to define a specific size for the icon (default is 20)
 * @prop {Boolean} light - used to display the icon in the light color (default white)
 * @prop {Boolean} disabled - used to disable the iconbutton (no pointer events)
 * @prop {Boolean} notify - used to display notify badge in upper right corner
 *
 */
let SDBContentIconButton = class SDBContentIconButton extends LitElement {
    constructor() {
        super(...arguments);
        this.icon = '';
        this.link = '';
        this.target = '_self';
        this.size = 20;
        this.disabled = false;
        this.light = false;
        this.notify = false;
    }
    render() {
        // rendering <a href=""> results in navigation on click.
        // use a simple span when there's no link property
        return html `
            ${this.link && this.link.length
            ? html `<a
                      class="iconButton"
                      href="${this.link}"
                      target="${this.target}"
                      >${this.renderNotify()} ${this.renderIcon()}</a
                  >`
            : html `<div class="iconButton">
                      ${this.renderNotify()} ${this.renderIcon()}
                  </div>`}
        `;
    }
    renderIcon() {
        return html `
            <sdb-content-icon
                .size=${this.size}
                .icon=${this.icon}
            ></sdb-content-icon>
        `;
    }
    renderNotify() {
        return html `<span class="notify"></span>`;
    }
};
SDBContentIconButton.styles = [
    elements,
    css `
            :host .iconButton {
                position: relative;
                display: inline-block;
                margin: 5px;
                background: transparent;
                border: none;
                color: var(--text-primary);
                cursor: pointer;
                text-transform: uppercase;
                font: var(--font-default);
                transition: scale 0.1s ease-in-out;
                -webkit-transform: rotateZ(360deg);
                vertical-align: middle;
            }

            :host([disabled]) {
                pointer-events: none;
            }

            :host([disabled]) .iconButton {
                color: var(--element-disabled);
            }

            :host([light]) .iconButton {
                color: var(--text-light);
            }

            :host .iconButton:focus {
                outline: none !important;
            }

            :host .iconButton:hover {
                transform: var(--sdb-button-scale-factor, scale(1.05));
            }

            .notify {
                display: none;
            }

            :host([notify]) .notify {
                display: block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background: var(--btn-primary);
                position: absolute;
                top: -10px;
                right: -5px;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentIconButton.prototype, "icon", void 0);
__decorate([
    property({ type: String })
], SDBContentIconButton.prototype, "link", void 0);
__decorate([
    property({ type: String })
], SDBContentIconButton.prototype, "target", void 0);
__decorate([
    property({ type: Number })
], SDBContentIconButton.prototype, "size", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentIconButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentIconButton.prototype, "light", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBContentIconButton.prototype, "notify", void 0);
SDBContentIconButton = __decorate([
    customElement('sdb-content-iconbutton')
], SDBContentIconButton);
export { SDBContentIconButton };
//# sourceMappingURL=sdb-content-iconbutton.js.map